export enum ContentControlledReportableEventBy {
  System = 1,
  AI,
}
